import { AdminExamCourseEnablementButton } from '@exam-center/admin-exam-course-enablement';
import { MenuBookOutlinedIcon, NoRowsOverlay } from '@shared/components';

export default function AdminExamCourseListNoRowsOverlay() {
  return (
    <NoRowsOverlay
      icon={MenuBookOutlinedIcon}
      title='ไม่มีข้อมูลหลักสูตร'
      description='กรุณาเพิ่มหลักสูตรเพื่อเริ่มจัดการข้อมูลหลักสูตร'
      action={<AdminExamCourseEnablementButton variant='outlined' />}
    />
  );
}
